import { storageGetItem } from "@/Common/helpers/Storage";
import { IUser } from "@/Common/interfaces/user";
import { ReactNode, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
// Redux
import { actions } from "@/redux/reducers/User";
import { useDispatch } from "react-redux";

type UnprotectedRouteProps = {
	children?: ReactNode;
	component?: (tabId: string, messageMethod: Function) => ReactNode;
};

const DASHBOARD_ROUTE = "/dashboard";

const UnprotectedRoute = ({ children, component }: UnprotectedRouteProps) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [tabId, setTabId] = useState<string>("");

	const user = storageGetItem("loggedUser") as IUser | null;

	const onMessage = (paramMessage: { tabId: string; loggedIn: boolean; logged: IUser }) => {
		if (paramMessage.tabId !== tabId && paramMessage.loggedIn) {
			const storageUser = storageGetItem("loggedUser") as IUser | null;
			dispatch(actions.SET_USER({ user: paramMessage.logged }));
			if (storageUser) {
				navigate(storageUser.preferences?.landingPage ?? DASHBOARD_ROUTE);
			}
		}
	};

	const { getTabId, message } = useIdleTimer({
		onMessage,
		timeout: 100000000,
		crossTab: true,
		leaderElection: true,
		syncTimers: 200,
	});

	useEffect(() => {
		const interval = setInterval(() => {
			setTabId(String(getTabId()));
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, []);

	useEffect(() => {
		if (user) {
			navigate(user.preferences?.landingPage ?? DASHBOARD_ROUTE);
		}
	}, [user]);

	if (component) {
		return component(tabId, message);
	}

	return <>{children}</>;
};

export default UnprotectedRoute;
